// JAPAN WEB CLINIC (Dawn) — the medicines list's search and symptom buttons (sections/jwc-catalog.liquid; owner
// 2026-10-20). Everything is on the page already (about 25 medicines), so the list narrows at each letter without asking
// the server. The typed words and each medicine's words (data-words, '|' between them) are made alike first: NFKC
// (full-width letters and half-width kana), small letters, katakana as hiragana, no spaces or punctuation. A medicine
// is found when the whole query, or each of its words, is part of one of its words. Searching and a symptom button do
// not combine: typing goes back to 「すべて」, a button empties the box. ?q= and ?cat= follow (replaceState), so a link
// can open a search or one symptom; other parameters (such as ?view=) stay.
// The button row (or the box, while typing) keeps its place on the screen (owner 2026-10-21: choosing another symptom
// jumped, even to the end of the list): 「人気の薬」 above the row hides and comes back, and the list gets shorter or
// longer; iPhones do not keep the place by themselves (no scroll anchoring) and no browser does at the page's top. So the
// row's place is read before the change and the page is scrolled back to it after, with the browser's own anchoring off
// (jwc-catalog.css); when the page would be too short for that, the results keep a minimum height. The row's sideways
// scroll stays too.
(function () {
  const norm = (s) =>
    String(s || '')
      .normalize('NFKC')
      .toLowerCase()
      .replace(/[ァ-ヶ]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0x60))
      .replace(/[\s\-‐‑–—―・･·.,，、。'’"“”()（）[\]［］「」『』〈〉《》【】/／!！?？:：;；~〜]/g, '');

  function setup(root) {
    const form = root.querySelector('[data-jwc-catalog-form]');
    const input = root.querySelector('[data-jwc-catalog-q]');
    const clear = root.querySelector('[data-jwc-catalog-clear]');
    const popular = root.querySelector('[data-jwc-catalog-popular]');
    const count = root.querySelector('[data-jwc-catalog-count]');
    const empty = root.querySelector('[data-jwc-catalog-empty]');
    const site = root.querySelector('[data-jwc-catalog-site]');
    const cats = root.querySelector('[data-jwc-catalog-cats]');
    const row = cats?.querySelector('.jwc-catalog__cats-row');
    const results = root.querySelector('[data-jwc-catalog-results]');
    const radios = [...root.querySelectorAll('[data-jwc-catalog-cats] input[type="radio"]')];
    const items = [...root.querySelectorAll('[data-jwc-item]')].map((li) => ({
      li,
      tags: (li.dataset.tags || '').split(' '),
      words: (li.dataset.words || '').split('|').map(norm).filter(Boolean),
    }));
    const one = root.dataset.countOne || '%n';
    const other = root.dataset.countOther || '%n';
    const cat = () => radios.find((r) => r.checked)?.value || '';

    function setCat(value) {
      const r = radios.find((x) => x.value === value) || radios[0];
      if (r) r.checked = true;
    }
    function found(item, q, parts) {
      const has = (w) => item.words.some((x) => x.includes(w));
      return has(q) || (parts.length > 1 && parts.every(has));
    }
    function writeUrl(q, c) {
      const url = new URL(window.location.href);
      url.searchParams.delete('options[prefix]');
      if (q) url.searchParams.set('q', q);
      else url.searchParams.delete('q');
      if (c) url.searchParams.set('cat', c);
      else url.searchParams.delete('cat');
      history.replaceState(history.state, '', url);
    }
    function apply() {
      const raw = input ? input.value.trim() : '';
      const q = norm(raw);
      const parts = raw.split(/\s+/).map(norm).filter(Boolean);
      const c = cat();
      let n = 0;
      items.forEach((item) => {
        const show = q ? found(item, q, parts) : !c || item.tags.includes(c);
        item.li.hidden = !show;
        if (show) n++;
      });
      if (popular) popular.hidden = Boolean(q || c);
      if (clear) clear.classList.toggle('hidden', !raw);
      if (count) {
        count.textContent = (n === 1 ? one : other).replace('%n', n);
        count.hidden = n === 0;
      }
      if (empty) {
        empty.hidden = n > 0;
        if (site) {
          site.textContent = (root.dataset.siteText || '%q').replace('%q', raw);
          site.href = `${root.dataset.searchUrl}?q=${encodeURIComponent(raw)}&options%5Bprefix%5D=last`;
          site.parentElement.hidden = !raw;
        }
      }
      writeUrl(raw, q ? '' : c);
    }

    // apply() without moving `anchor` (the button row or the search box) on the screen
    function steady(anchor) {
      const before = anchor ? anchor.getBoundingClientRect().top : null;
      const left = row ? row.scrollLeft : 0;
      if (results) results.style.minHeight = '';
      apply();
      if (row) row.scrollLeft = left;
      if (before === null) return;
      const want = window.scrollY + anchor.getBoundingClientRect().top - before;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (results && want > max) results.style.minHeight = `${results.offsetHeight + want - max}px`;
      window.scrollTo({ top: Math.max(0, want), behavior: 'instant' });
    }

    // from the address: ?q= (the header's search comes here) or ?cat=
    const params = new URLSearchParams(window.location.search);
    if (input && params.get('q')) input.value = params.get('q');
    else if (params.get('cat')) setCat(params.get('cat'));

    input?.addEventListener('input', (e) => {
      if (e.isComposing) return; // Chinese and Korean keyboards: when the word is confirmed (compositionend)
      if (input.value.trim() && cat()) setCat('');
      steady(form);
    });
    input?.addEventListener('compositionend', () => {
      if (input.value.trim() && cat()) setCat('');
      steady(form);
    });
    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      input?.blur();
      steady(form);
    });
    clear?.addEventListener('click', () => {
      input.value = '';
      steady(form);
      input.focus({ preventScroll: true });
    });
    radios.forEach((r) =>
      r.addEventListener('change', () => {
        if (input) input.value = '';
        steady(cats);
      })
    );
    root.querySelector('[data-jwc-catalog-reset]')?.addEventListener('click', () => {
      if (input) input.value = '';
      setCat('');
      steady(cats);
    });
    apply();
  }

  function start() {
    document.querySelectorAll('[data-jwc-catalog]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
